import { render, staticRenderFns } from "./TriggerEndpointSelector.vue?vue&type=template&id=48139bc4&"
import script from "./TriggerEndpointSelector.vue?vue&type=script&lang=js&"
export * from "./TriggerEndpointSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports